import * as React from 'react';
import { Styler, StylerBaseProps } from '../Styler';
import { useStyles } from './BackgroundImage.styles';
import { useForkRef, useLazyImage } from '../../hooks';

// export interface BackgroundImageProps extends StylerBaseProps {
//     /**
//      * CSS background-image value.
//      * May be lazily applied when a lazy image provider is present.
//      */
//     backgroundImage?: string;

//     /**
//      * CSS background-repeat value.
//      */
//     backgroundRepeat?: React.CSSProperties['backgroundRepeat'];
// }

export function BackgroundImage(props: Readonly<StylerBaseProps>): React.JSX.Element {
    const { backgroundImage = 'none', backgroundRepeat = 'no-repeat', ref, ...other } = props;

    // If we have a lazy image provider then the `background-image`
    // CSS property will be lazily set.
    const [lazyImageRef] = useLazyImage();
    const isLazy = lazyImageRef !== null;

    const handleRef = useForkRef(ref, lazyImageRef);

    const { styles } = useStyles({
        backgroundImage,
        isLazy,
    });

    return <Styler ref={handleRef} css={styles.root} backgroundRepeat={backgroundRepeat} {...other} />;
}
